module.exports = __webpack_public_path__ + "static/bluebird-2c102ac90eb770e8e7df45e365462a92.svg";